var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoLineChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 11.25C9.75 10.0074 10.7574 9 12 9C13.2426 9 14.25 10.0074 14.25 11.25V20C14.25 20.4142 13.9142 20.75 13.5 20.75H10.5C10.0858 20.75 9.75 20.4142 9.75 20V11.25Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 12.75C4.25736 12.75 3.25 13.7574 3.25 15V20C3.25 20.4142 3.58579 20.75 4 20.75H7C7.41421 20.75 7.75 20.4142 7.75 20V15C7.75 13.7574 6.74264 12.75 5.5 12.75Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 10.5C17.2574 10.5 16.25 11.5074 16.25 12.75V20C16.25 20.4142 16.5858 20.75 17 20.75H20C20.4142 20.75 20.75 20.4142 20.75 20V12.75C20.75 11.5074 19.7426 10.5 18.5 10.5Z",
    fill: "currentColor"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.25C11.0335 3.25 10.25 4.0335 10.25 5C10.25 5.04731 10.2519 5.09418 10.2556 5.14054L6.49497 7.31011C6.21249 7.11456 5.86967 7 5.5001 7C4.5336 7 3.75 7.7835 3.75 8.75C3.75 9.7165 4.5335 10.5 5.5 10.5C6.4665 10.5 7.2501 9.7165 7.2501 8.75C7.2501 8.70267 7.24822 8.65578 7.24453 8.6094L11.0051 6.43986C11.2876 6.63543 11.6304 6.75 12 6.75C12.556 6.75 13.0516 6.49067 13.3722 6.08636L16.7903 6.87517C16.962 7.66138 17.6623 8.25 18.5 8.25C19.4665 8.25 20.2501 7.4665 20.2501 6.5C20.2501 5.5335 19.4666 4.75 18.5001 4.75C17.9441 4.75 17.4485 5.00934 17.1279 5.41366L13.7098 4.62486C13.5381 3.83863 12.8377 3.25 12 3.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoLineChart);
export default __webpack_public_path__ + "static/media/DuoLineChart.875dabc568cf052cee9d5b088a3e55f9.svg";
export { ForwardRef as ReactComponent };